import { render, staticRenderFns } from "./IPWhitelist.vue?vue&type=template&id=4853ea18&scoped=true"
import script from "./IPWhitelist.vue?vue&type=script&lang=js"
export * from "./IPWhitelist.vue?vue&type=script&lang=js"
import style0 from "./IPWhitelist.vue?vue&type=style&index=0&id=4853ea18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4853ea18",
  null
  
)

export default component.exports